export default __webpack_public_path__ + "static/media/portfolio_3.276023f3.png";